var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconIndicar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.333,
    height: 24.783,
    viewBox: "0 0 27.333 24.783",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.275 9.276)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M351.392,157.69a3.119,3.119,0,0,1-3.116-3.115V145.3a3.116,3.116,0,0,1,6.232,0v5.314a6.166,6.166,0,0,0,2.408-2.588.719.719,0,1,1,1.288.638,7.593,7.593,0,0,1-4.164,3.758.718.718,0,0,1-.97-.673V145.3a1.678,1.678,0,0,0-3.356,0v9.276a1.68,1.68,0,0,0,1.678,1.678,10.93,10.93,0,0,0,9.739-5.943.719.719,0,1,1,1.277.66A12.362,12.362,0,0,1,351.392,157.69Z",
    transform: "translate(-348.276 -142.183)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M330.145,136.443a3.119,3.119,0,0,1-3.115-3.116,12.388,12.388,0,0,1,22.424-7.265.719.719,0,0,1-1.164.844,10.951,10.951,0,0,0-19.824,6.421,1.678,1.678,0,1,0,3.356,0A7.6,7.6,0,0,1,345.662,129a.719.719,0,1,1-1.18.821,6.158,6.158,0,0,0-11.221,3.508A3.119,3.119,0,0,1,330.145,136.443Z",
    transform: "translate(-327.03 -120.936)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.205 7.026)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M373.294,146.159a1.09,1.09,0,0,1-1.089-1.09v-2.385h-2.386a1.089,1.089,0,0,1,0-2.179h2.386v-2.385a1.089,1.089,0,0,1,2.178,0V140.5h2.385a1.089,1.089,0,1,1,0,2.179h-2.385v2.385A1.09,1.09,0,0,1,373.294,146.159Zm3.475-4.216h0Z",
    transform: "translate(-368.73 -137.03)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIndicar);
export default __webpack_public_path__ + "static/media/icon_indicar.53f997e5.svg";
export { ForwardRef as ReactComponent };